import AdminUsers from 'components/Admin/User/List/AdminUsers';

const AdminUsersPageList = () => {
	return <AdminUsers />;
};

export default AdminUsersPageList;
